import './style/index.js';

import _Layout from './Layout';

export type { LayoutProps } from './Layout';
export * from './type';

export const Layout = _Layout;
export default Layout;
